var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelStackActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.559,
    height: 9.781,
    viewBox: "0 0 11.559 9.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "card-stack-svgrepo-com",
    d: "M1.889,3.334a.445.445,0,0,1,.445-.445h8.892a.445.445,0,0,1,.445.445V8.669a.445.445,0,0,1-.445.445H2.334a.445.445,0,0,1-.445-.445Zm0,6.593A1.334,1.334,0,0,1,1,8.669V3.334A1.334,1.334,0,0,1,2.334,2h8.892a1.334,1.334,0,0,1,1.334,1.334V8.669a1.334,1.334,0,0,1-.889,1.258v.521a1.334,1.334,0,0,1-1.334,1.334H3.223a1.334,1.334,0,0,1-1.334-1.334ZM10.781,10v.445a.445.445,0,0,1-.445.445H3.223a.445.445,0,0,1-.445-.445V10Z",
    transform: "translate(-1 -2)",
    fill: "#165cf3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelStackActive);
export default __webpack_public_path__ + "static/media/channel-stack-active.cc979a7180c8ad349235ed539b2f0703.svg";
export { ForwardRef as ReactComponent };